import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import logo from "../../Images/buillogo6.png";
import { FaDownload } from "react-icons/fa"; // Import the download icon
import { showErrorToast, showSuccessToast } from "../../utils/toaster";
import axios from "axios";
import { baseurl } from "../../config/url";
import generateInvoice from "../../utils/dowloadinvoice";
import { calculateDepositCharges, calculateHireVisibilityCharges } from "../../utils/calculateVisibilityCharges";

function AddProductInvoice({
  visibilityPrice = 0,
  powerPackPrice,
  ammount,
  maxquantity,
  saleMode,
  products,
  visibilityLevel,
  hsnCode,
  categoryName, 
  subcategoryName, 

}) {
  const [sellerdetails, setsellerdetails] = useState();
  const [calculatedVisibilityCharges, setCalculatedVisibilityCharges] =
  useState(0);
  const [visibiliyCalculationDetails, setVisibilityCalculationDetails] =
  useState("");

  const formattedDate = dayjs().format("DD MMMM YYYY");
   //  Deposit Calculation Logic
  let depositAmount = 0;
  let depositPercentage = 0;

  if (saleMode === "Sale By OGCS") {
    try {
      // Call utility function for calculation
      depositAmount = calculateDepositCharges(categoryName, subcategoryName, ammount, maxquantity);
      
      console.log("💰 Calculated Deposit Amount:", depositAmount);

      //  Deposit percentage mapping
      const depositPercentages = {
        "Hand Tools": {
          "Manual Hand Tool": 6,
          "Electrical hand tool": 6,
          "Hydrolic Hand Tool": 6,
          "Electrical Hand Tool": 6, // Added missing subcategory
    
        },
        "Small Equipment": {
          "Concrete mixtures": 5,
          "Concrete Mixing Tools": 5,
          "Surveying and Measurement Tools": 5,
          "Excavation and Digging Tools": 5,
          "Compaction and Tamping Tools": 5,
          "Finishing and Smoothing Tools": 5,
          "Vibrators for Concrete": 5,
        },
        "Structural Material": {
          "Reinforcement steel": 1,
          "Hot Rolled Deformed Bars": 1,
          "Cold Rolled Steel Bars": 1,
          "Mild Steel Bars": 1,
          "Welded Steel Wire.": 1,
          "Prestressing steel bars": 1,
          "Epoxy coated rebar": 1,
          "High yield strength deformed (HYSD) bar": 1,
          "Structural steel Deferent section and size": 1,
          "Alloy steel": 1,
          "Heat-treated carbon steel": 1,
          "Heat-treated alloy steel.": 1 ,
        },
        "Bulk Material/Construction Materials": {
          "Concrete Block": 5,
          "Bricks": 5,
          "Fly Ash ": 5,
          "Bituminous Materials": 4,
          "Sand and Aggregates": 10,
          "Cement and Cement Products": 2,
        },
        "Heavy Equipment": {
          "Concrete Batching Plants": 5,
          "Forklifts and Pallet Jacks": 5,
          "Concrete Pumps": 5,
          "Boom Placers": 5,
          "Porta cabin": 5,
          "Specialized Heavy Equipment's": 5,
          "Power Trencher": 5,
          "Transport Equipment": 5,
          "Plastering and Masonry Equipment": 8.5,
          "Cranes": 8.5,
          "Concrete Equipment": 8.5,
          "Rollers": 5,
          "Excavators and Loaders": 5,
        },
        "Contruction Chemical and Materials": {
          "Concrete Hardeners": 5,
          "Waterproofing Solutions": 5,
          "Surface Treatments": 5,
          "Bonding and Adhesive Agents": 5,
          "Protective Coatings": 5,
          "Grouts and Repair Mortars": 5,
          "Admixtures for Concrete": 5,
          "Insulation Materials": 5,
          "Tiles and Pavers": 5,
          "Joints and Panels": 5,
          "Expansion Joints and Water Stoppers": 5,
          "Paint" : 3 ,
          "Fastener and Anchor" :5,
          "Nails and Screws" :5,
            },
    
        "Finishing Items": {
          "Rolling Shutters": 5,
          "Windows": 5,
          "Doors": 5,
          "Water Heaters": 5,
          "Sanitary Fixtures": 5,
          "Water Supply Fixtures": 5,
          "Valves": 5,
          "Pipe Fittings": 5,
          "Galvanized Steel Pipes": 5,
          "Copper Pipes": 5,
          "PEX Pipes (Cross-Linked Polyethylene)": 5,
          "CPVC Pipes (Chlorinated Polyvinyl Chloride)": 5,
          "PVC Pipes (Polyvinyl Chloride)": 5,
        },
        "Form Work Material": {
          "Formwork Panels (Modular)": 5,
          "wooden batten": 5,
          "Playwood": 5,
          "Additional Formwork Components": 5,
          "Doka Components": 5,
          "Cup Lock Scaffolding System": 5,
          "Access Scaffolding": 5,
          "HDT System": 5,
          "Wall/Column Formwork": 5,
          "Advanced Scaffolding Systems": 5,
          "Basic Formwork Components": 5,
        },
        "Specialized Equipment's": {
          "Dewatering pumps": 4,
          "D.G.Sets": 4,
          "Specialized Testing Equipment": 4,
          "Specialized Equipment": 4,
          "GPS and Total Stations": 4,
          "Surveying Instruments": 4,
        },
        "Safety Items": {
          "First Aid and Fire Safety Equipment": 5,
          "Fall Protection Equipment": 5,
          "Personal Protective Equipment (PPE)": 5,
        },
//Electrical Materials
        
    "Electrical Materials" : {
      "Conduits and Fittings": 5,
      "Wires and Cables": 7,
      "Switches and Sockets": 7,
      "Light Fixtures": 7,
      "Distribution Boards and Protection Devices": 10,
      "Earthing and Lightning Protection": 10,
      "Control Panels and Accessories": 5,
      "Communication & Safety": 5,
      "Miscellaneous Items": 10,

    },

      };

      // Fetch deposit percentage, default to 0 if not found
      depositPercentage = depositPercentages?.[categoryName]?.[subcategoryName] || 0;
      console.log("💰 Deposit Percentage:", depositPercentage);
    } catch (error) {
      console.error("❌ Error in deposit calculation:", error.message);
    }
  }


    //const totalAmountBeforeGST = visibilityPrice + powerPackPrice ;
  
    //const gstPercentage = 18;
   // const gstAmount = Math.round(totalAmountBeforeGST * (gstPercentage / 100));
  // Calculate 12% of the depositAmount

  // const depositTax = Math.round(depositAmount * 0.12);
  // depositAmount = depositTax
  const totalAmount = visibilityPrice + powerPackPrice + depositAmount ;



 // Function to calculate visibility charges

 
 const calculateVisibilityCharges = (price, maxquantity, visibilityLevel) => {
  if (!price || !maxquantity || !visibilityLevel) {
    return { charges: 0, details: "" };
  }

  const normalizedVisibilityLevel = visibilityLevel.toUpperCase();
  const productValue = price * maxquantity;
  let charges;
  let details = `Product Value (Price × Max Quantity): ₹${price} × ${maxquantity} = ₹${productValue}\n`;

  if (productValue >= 500000) {
    const tierCharges = {
      "1X": 110000,
      "2X": 121000,
      "3X": 133100,
      "4X": 146400,
    };
    charges = tierCharges[normalizedVisibilityLevel];
    details += `Product Value >= ₹500,000, Charges for ${normalizedVisibilityLevel}: ₹${charges}`;
  } else if (productValue >= 200000) {
    const tierCharges = {
      "1X": 95000,
      "2X": 104500,
      "3X": 114950,
      "4X": 126445,
    };
    charges = tierCharges[normalizedVisibilityLevel];
    details += `Product Value >= ₹200,000, Charges for ${normalizedVisibilityLevel}: ₹${charges}`;
  } else {
    const valueMultipliers = {
      "1X": 4,
      "2X": 6,
      "3X": 8,
      "4X": 11,
    };

    const minMaxCharges = {
      "1X": { min: 15000, max: 90000 },
      "2X": { min: 19500, max: 99000 },
      "3X": { min: 25350, max: 108900 },
      "4X": { min: 32955, max: 119790 },
    };

    const calculatedCharge =
      productValue * valueMultipliers[normalizedVisibilityLevel];
    charges = Math.max(
      minMaxCharges[normalizedVisibilityLevel].min,
      Math.min(calculatedCharge, minMaxCharges[normalizedVisibilityLevel].max)
    );
    details += `Product Value < ₹200,000:\n  Base Charge (Value × Multiplier): ₹${productValue} × ${
      valueMultipliers[normalizedVisibilityLevel]
    } = ₹${calculatedCharge}\n  Min/Max Applied: ₹${charges}`;
  }

  return { charges, details };
};

// useEffect(() => {
//   if (products?.length > 0) {
//     const product = products[0];
//     const { charges, details } = calculateVisibilityCharges(
//       product.productPrice,
//       product.maxquantity,
//       product.visibilityLevel
//     );
//     console.log("Calculated Charges:", charges);
//     console.log("Visibility Details:", details);

//     setCalculatedVisibilityCharges(charges);
//     setVisibilityCalculationDetails(details);
//   }
// }, [products]);

useEffect(() => {
  if (products?.length > 0) {
    const product = products[0];

    let charges = 0;
    let details = "";

    const isHireMode = saleMode === "Sale By Seller" && product?.saleProduct === "Hire";

  if (isHireMode) {
  const hireChargePerUnit = Number(product?.hireChargeAmount || 0);
  const hireQty = Number(product?.maxquantity || 0);

  const hireDurationValue = Number(product?.hireDuration?.value) || 0;
  const hireDurationUnit = product?.hireDuration?.unit || "days";
  const hireType = product?.selectedHireType || "days";

  const unitConversion = () => {
    if (hireType === "days") {
      if (hireDurationUnit === "days") return hireDurationValue;
      if (hireDurationUnit === "weeks") return hireDurationValue * 7;
      if (hireDurationUnit === "months") return hireDurationValue * 30;
    }
    if (hireType === "weeks") {
      if (hireDurationUnit === "days") return hireDurationValue / 7;
      if (hireDurationUnit === "weeks") return hireDurationValue;
      if (hireDurationUnit === "months") return hireDurationValue * 4.345;
    }
    if (hireType === "months") {
      if (hireDurationUnit === "days") return hireDurationValue / 30;
      if (hireDurationUnit === "weeks") return hireDurationValue / 4.345;
      if (hireDurationUnit === "months") return hireDurationValue;
    }
    return 0;
  };

  const convertedDuration = unitConversion();

  const monthlyHireValue = Math.round(hireChargePerUnit * hireQty * convertedDuration);

  const visibilityLevel = product?.visibilityLevel;

  charges = calculateHireVisibilityCharges(monthlyHireValue, visibilityLevel);
  details = `Hire Visibility Calculation:\nMonthly Hire Value: ₹${monthlyHireValue}\nVisibility Level: ${visibilityLevel}\nCalculated Visibility Charge: ₹${charges}`;
}


    console.log("Calculated Charges:", charges);
    console.log("Visibility Details:", details);

    setCalculatedVisibilityCharges(charges);
    setVisibilityCalculationDetails(details);
  }
}, [products, saleMode]);


const handleDownloadInvoice = () => {
  console.log("Visibility Calculation Details Before Download:", visibiliyCalculationDetails);


  try {
    generateInvoice(
      sellerdetails,
        calculatedVisibilityCharges,
      powerPackPrice,
      depositAmount,
      products,
      `INV-${Date.now()}`,
      visibilityLevel,
      hsnCode,
      visibiliyCalculationDetails
    );

    console.log("Visibility Calculation Details after Download:", visibiliyCalculationDetails);
    showSuccessToast("Invoice downloaded successfully!");
  } catch (error) {
    console.error("Error generating invoice:", error);
    showErrorToast("Failed to download invoice. Please try again.");
  }
};

  const getSellerDetails = async () => {
    try {
      const sellerId = localStorage.getItem("sellerId");

      if (!sellerId) {
        showErrorToast("Seller ID is not available in localStorage");
        return;
      }
      // Make the API call
      const response = await axios.get(
        `${baseurl}/api/seller/seller-by-id/${sellerId}`
      );
      setsellerdetails(response?.data || {});
    } catch (error) {
      showErrorToast("Error fetching seller details");
    }
  };

  useEffect(() => {
    getSellerDetails();
  }, []);

  const totalAmountBeforeGST = calculatedVisibilityCharges  + powerPackPrice;

  // GST is calculated only on visibilityPrice and powerPackPrice
  const gstPercentage = 18;
  const gstAmount = Math.round(totalAmountBeforeGST * (gstPercentage / 100));
  
  // Final total amount including GST, excluding deposit
  const totalAmountWithGST = totalAmountBeforeGST + gstAmount;
  
  // Final total amount including deposit, but deposit has no GST
  const finalTotalAmount = totalAmountWithGST + depositAmount;
  
  return (
    <div className="max-w-3xl mx-auto bg-white p-8 shadow-sm border border-gray-300">
      {/* Invoice Header */}
      <div className="mb-8 flex items-center justify-between">
        <div>   
          <div className="text-2xl font-bold text-gray-800">
          Performa Invoice
          </div>
          <p className="text-gray-600">Date: {formattedDate}</p>
        </div>
        <div>
          {/* Logo */}
          <img src={logo} alt="Logo" className="w-32 h-auto" />
        </div>
      </div>

      <div>
        {/* Seller Details */}
        <div className="mb-6">
          <h2 className="text-lg font-semibold text-gray-700 border-b pb-2 mb-2">
            Seller Details
          </h2>
          {sellerdetails ? (
            <>
              <p className="text-gray-600 text-base">{sellerdetails.companyName}</p>
              <p className="text-gray-600 text-base">
                {sellerdetails.address.street}, {sellerdetails.address.city},{" "}
                {sellerdetails.address.state}, {sellerdetails.address.country} -{" "}
                {sellerdetails.address.postalCode}
              </p>
              <p className="text-gray-600 text-base">
                Contact: {sellerdetails.mobile}
              </p>
              <p className="text-gray-600 text-base">
                Email: {sellerdetails.email}
              </p>
            </>
          ) : (
            <p className="text-gray-500">Loading seller details...</p>
          )}
        </div>

         {/* Charges Section */}
         <div className="mb-8">
          <h3 className="text-lg font-semibold text-gray-700 border-b pb-2 mb-2">
            Charges Breakdown
          </h3>

          <div className="space-y-2">
            {products && products[0]?.visibilityLevel && (
              <p className="text-gray-600 text-base">
                Visibility Charges ({products[0].visibilityLevel}): ₹
                {calculatedVisibilityCharges}
              </p>
            )}
            <pre className="text-sm text-gray-600 whitespace-pre-wrap">
              {visibiliyCalculationDetails}
            </pre>
            <p className="text-gray-600 text-base">
              Powerpack Charges: ₹{powerPackPrice}
            </p>
            {saleMode === "Sale By OGCS" && (
              <p className="text-gray-600 text-base">
                Deposit Charges: ₹{depositAmount}
              </p>
            )}
             <p className="text-gray-600 text-base">GST (18% on Visibility + PowerPack): ₹{gstAmount}</p>
          </div>

          <div className="mb-3 border-b pb-3">
            <h3 className="font-semibold text-gray-700">Total Amount</h3>
            <p className="text-gray-800 font-bold">₹{finalTotalAmount}</p>
          </div>

          {/* Explanation of Visibility Charge */}
          <div className="text-gray-600">
            <div className="font-semibold text-gray-700 mb-1">
              How Visibility Charges are Calculated
            </div>
            <ul className="list-disc pl-5 text-base">
              <li>
                The "Visibility" charge is based on the total exposure the
                product receives across various platforms.
              </li>
              <li>
                Factors such as product placement, advertising exposure, and
                reach influence this charge.
              </li>
              <li>
                The final visibility charge for this invoice is ₹
                {visibilityPrice}.
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Product Details */}
      <div className="overflow-x-auto">
        <table className="w-full border border-gray-300 rounded-lg text-left">
          <thead className="bg-gray-100">
            <tr>
              <th className="py-3 px-4 text-gray-700">Product</th>
              <th className="py-3 px-4 text-gray-700">Price</th>
              <th className="py-3 px-4 text-gray-700">Max Quantity</th>
              <th className="py-3 px-4 text-gray-700">HSN Code</th>
              <th className="py-3 px-4 text-gray-700">Visibility Level</th>

            </tr>
          </thead>
          <tbody>
  {products &&
    products.map((product, index) => {
      return (
        <tr key={index} className="border-b hover:bg-gray-50">
          <td className="py-2 px-4">{product?.productName || "N/A"}</td>
          <td className="py-2 px-4">₹{product?.productPrice || "N/A"}</td>
          <td className="py-2 px-4">{product?.maxquantity || "N/A"}</td>
          <td className="py-2 px-4">{product?.hsncode || "N/A"}</td>
          <td className="py-2 px-4">{product?.visibilityLevel || "N/A"}</td>
        </tr>
      );
    })}
</tbody>



        </table>
      </div>

      {/* <div> */}
      {/* Charges Section
      <div className="mb-8">
        <h3 className="text-lg font-semibold text-gray-700 border-b pb-2 mb-2">
          Charges Breakdown
        </h3>

        <div className="space-y-2">
          {products && products[0]?.visibilityLevel && (
            <p className="text-gray-600 text-base">
              Visibility Charges ({products[0].visibilityLevel}): ₹
              {calculatedVisibilityCharges}
            </p>
          )}
          <pre className="text-sm text-gray-600 whitespace-pre-wrap">
            {visibiliyCalculationDetails}
          </pre>
          <p className="text-gray-600 text-base">Powerpack Charges: ₹{powerPackPrice}</p>
          {saleMode === "Sale By OGCS" && (
            <p className="text-gray-600 text-base">Deposit Charges: ₹{depositAmount}</p>
          )}
          <p className="text-gray-600 text-base">GST (18%): ₹{gstAmount}</p>
        </div>

        <div className="mb-3 border-b pb-3">
          <h3 className="font-semibold text-gray-700">Final Total Amount</h3>
          <p className="text-gray-800 font-bold">₹{finalTotalAmount}</p>
        </div>
      </div>
    </div> */}

      {/* Download Button */}
      <div className="mt-6 flex justify-end">
        <button
          onClick={handleDownloadInvoice}
          className="flex items-center py-2 px-4 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
        >
          <FaDownload className="mr-2" />
          Download Invoice
        </button>
      </div>
    </div>
  );
}

export default AddProductInvoice;






















// import React, { useEffect, useState } from "react";
// import dayjs from "dayjs";
// import logo from "../../Images/buillogo6.png";
// import { FaDownload } from "react-icons/fa"; // Import the download icon
// import { showErrorToast, showSuccessToast } from "../../utils/toaster";
// import axios from "axios";
// import { baseurl } from "../../config/url";
// import generateInvoice from "../../utils/dowloadinvoice";

// function AddProductInvoice({
//   visibilityPrice = 0,
//   powerPackPrice,
//   ammount,
//   maxquantity,
//   saleMode,
//   products,
//   visibilityLevel,
//   hsnCode

// }) {
//   const [sellerdetails, setsellerdetails] = useState();
//   const [calculatedVisibilityCharges, setCalculatedVisibilityCharges] =
//   useState(0);
//   const [visibiliyCalculationDetails, setVisibilityCalculationDetails] =
//   useState("");

//   const formattedDate = dayjs().format("DD MMMM YYYY");
//   let depositAmount = saleMode === "Sale By OGCS" ? ammount * maxquantity : 0;
//   // Calculate 12% of the depositAmount
//   const depositTax = Math.round(depositAmount * 0.12);
//   depositAmount = depositTax;
//   const totalAmount = visibilityPrice + powerPackPrice + depositAmount ;



//  // Function to calculate visibility charges

 
//  const calculateVisibilityCharges = (price, maxquantity, visibilityLevel) => {
//   if (!price || !maxquantity || !visibilityLevel) {
//     return { charges: 0, details: "" };
//   }

//   const normalizedVisibilityLevel = visibilityLevel.toUpperCase();
//   const productValue = price * maxquantity;
//   let charges;
//   let details = `Product Value (Price × Max Quantity): ₹${price} × ${maxquantity} = ₹${productValue}\n`;

//   if (productValue >= 500000) {
//     const tierCharges = {
//       "1X": 110000,
//       "2X": 121000,
//       "3X": 133100,
//       "4X": 146400,
//     };
//     charges = tierCharges[normalizedVisibilityLevel];
//     details += `Product Value >= ₹500,000, Charges for ${normalizedVisibilityLevel}: ₹${charges}`;
//   } else if (productValue >= 200000) {
//     const tierCharges = {
//       "1X": 95000,
//       "2X": 104500,
//       "3X": 114950,
//       "4X": 126445,
//     };
//     charges = tierCharges[normalizedVisibilityLevel];
//     details += `Product Value >= ₹200,000, Charges for ${normalizedVisibilityLevel}: ₹${charges}`;
//   } else {
//     const valueMultipliers = {
//       "1X": 4,
//       "2X": 6,
//       "3X": 8,
//       "4X": 11,
//     };

//     const minMaxCharges = {
//       "1X": { min: 15000, max: 90000 },
//       "2X": { min: 19500, max: 99000 },
//       "3X": { min: 25350, max: 108900 },
//       "4X": { min: 32955, max: 119790 },
//     };

//     const calculatedCharge =
//       productValue * valueMultipliers[normalizedVisibilityLevel];
//     charges = Math.max(
//       minMaxCharges[normalizedVisibilityLevel].min,
//       Math.min(calculatedCharge, minMaxCharges[normalizedVisibilityLevel].max)
//     );
//     details += `Product Value < ₹200,000:\n  Base Charge (Value × Multiplier): ₹${productValue} × ${
//       valueMultipliers[normalizedVisibilityLevel]
//     } = ₹${calculatedCharge}\n  Min/Max Applied: ₹${charges}`;
//   }

//   return { charges, details };
// };

// useEffect(() => {
//   if (products?.length > 0) {
//     const product = products[0];
//     const { charges, details } = calculateVisibilityCharges(
//       product.productPrice,
//       product.maxquantity,
//       product.visibilityLevel
//     );
//     console.log("Calculated Charges:", charges);
//     console.log("Visibility Details:", details);

//     setCalculatedVisibilityCharges(charges);
//     setVisibilityCalculationDetails(details);
//   }
// }, [products]);

// const handleDownloadInvoice = () => {
//   console.log("Visibility Calculation Details Before Download:", visibiliyCalculationDetails);


//   try {
//     generateInvoice(
//       sellerdetails,
//       visibilityPrice,
//       powerPackPrice,
//       depositAmount,
//       products,
//       `INV-${Date.now()}`,
//       visibilityLevel,
//       hsnCode,
//       visibiliyCalculationDetails
//     );

//     console.log("Visibility Calculation Details after Download:", visibiliyCalculationDetails);
//     showSuccessToast("Invoice downloaded successfully!");
//   } catch (error) {
//     console.error("Error generating invoice:", error);
//     showErrorToast("Failed to download invoice. Please try again.");
//   }
// };

//   const getSellerDetails = async () => {
//     try {
//       const sellerId = localStorage.getItem("sellerId");

//       if (!sellerId) {
//         showErrorToast("Seller ID is not available in localStorage");
//         return;
//       }
//       // Make the API call
//       const response = await axios.get(
//         `${baseurl}/api/seller/seller-by-id/${sellerId}`
//       );
//       setsellerdetails(response?.data || {});
//     } catch (error) {
//       showErrorToast("Error fetching seller details");
//     }
//   };

//   useEffect(() => {
//     getSellerDetails();
//   }, []);

//   const totalAmountBeforeGST = visibilityPrice + powerPackPrice;

//   // GST is calculated only on visibilityPrice and powerPackPrice
//   const gstPercentage = 18;
//   const gstAmount = Math.round(totalAmountBeforeGST * (gstPercentage / 100));
  
//   // Final total amount including GST, excluding deposit
//   const totalAmountWithGST = totalAmountBeforeGST + gstAmount;
  
//   // Final total amount including deposit, but deposit has no GST
//   const finalTotalAmount = totalAmountWithGST + depositAmount;
  
//   return (
//     <div className="max-w-3xl mx-auto bg-white p-8 shadow-sm border border-gray-300">
//       {/* Invoice Header */}
//       <div className="mb-8 flex items-center justify-between">
//         <div>   
//           <div className="text-2xl font-bold text-gray-800">
//           Performa Invoice
//           </div>
//           <p className="text-gray-600">Date: {formattedDate}</p>
//         </div>
//         <div>
//           {/* Logo */}
//           <img src={logo} alt="Logo" className="w-32 h-auto" />
//         </div>
//       </div>

//       <div>
//         {/* Seller Details */}
//         <div className="mb-6">
//           <h2 className="text-lg font-semibold text-gray-700 border-b pb-2 mb-2">
//             Seller Details
//           </h2>
//           {sellerdetails ? (
//             <>
//               <p className="text-gray-600 text-base">{sellerdetails.name}</p>
//               <p className="text-gray-600 text-base">
//                 {sellerdetails.address.street}, {sellerdetails.address.city},{" "}
//                 {sellerdetails.address.state}, {sellerdetails.address.country} -{" "}
//                 {sellerdetails.address.postalCode}
//               </p>
//               <p className="text-gray-600 text-base">
//                 Contact: {sellerdetails.mobile}
//               </p>
//               <p className="text-gray-600 text-base">
//                 Email: {sellerdetails.email}
//               </p>
//             </>
//           ) : (
//             <p className="text-gray-500">Loading seller details...</p>
//           )}
//         </div>

//          {/* Charges Section */}
//          <div className="mb-8">
//           <h3 className="text-lg font-semibold text-gray-700 border-b pb-2 mb-2">
//             Charges Breakdown
//           </h3>

//           <div className="space-y-2">
//             {products && products[0]?.visibilityLevel && (
//               <p className="text-gray-600 text-base">
//                 Visibility Charges ({products[0].visibilityLevel}): ₹
//                 {calculatedVisibilityCharges}
//               </p>
//             )}
//             <pre className="text-sm text-gray-600 whitespace-pre-wrap">
//               {visibiliyCalculationDetails}
//             </pre>
//             <p className="text-gray-600 text-base">
//               Powerpack Charges: ₹{powerPackPrice}
//             </p>
//             {saleMode === "Sale By OGCS" && (
//               <p className="text-gray-600 text-base">
//                 Deposit Charges: ₹{depositAmount}
//               </p>
//             )}
//              <p className="text-gray-600 text-base">GST (18% on Visibility + PowerPack): ₹{gstAmount}</p>
//           </div>

//           <div className="mb-3 border-b pb-3">
//             <h3 className="font-semibold text-gray-700">Total Amount</h3>
//             <p className="text-gray-800 font-bold">₹{finalTotalAmount}</p>
//           </div>

//           {/* Explanation of Visibility Charge */}
//           <div className="text-gray-600">
//             <div className="font-semibold text-gray-700 mb-1">
//               How Visibility Charges are Calculated
//             </div>
//             <ul className="list-disc pl-5 text-base">
//               <li>
//                 The "Visibility" charge is based on the total exposure the
//                 product receives across various platforms.
//               </li>
//               <li>
//                 Factors such as product placement, advertising exposure, and
//                 reach influence this charge.
//               </li>
//               <li>
//                 The final visibility charge for this invoice is ₹
//                 {visibilityPrice}.
//               </li>
//             </ul>
//           </div>
//         </div>
//       </div>

//       {/* Product Details */}
//       <div className="overflow-x-auto">
//         <table className="w-full border border-gray-300 rounded-lg text-left">
//           <thead className="bg-gray-100">
//             <tr>
//               <th className="py-3 px-4 text-gray-700">Product</th>
//               <th className="py-3 px-4 text-gray-700">Price</th>
//               <th className="py-3 px-4 text-gray-700">Max Quantity</th>
//               <th className="py-3 px-4 text-gray-700">HSN Code</th>
//               <th className="py-3 px-4 text-gray-700">Visibility Level</th>

//             </tr>
//           </thead>
//           <tbody>
//   {products &&
//     products.map((product, index) => {
//       return (
//         <tr key={index} className="border-b hover:bg-gray-50">
//           <td className="py-2 px-4">{product?.productName || "N/A"}</td>
//           <td className="py-2 px-4">₹{product?.productPrice || "N/A"}</td>
//           <td className="py-2 px-4">{product?.maxquantity || "N/A"}</td>
//           <td className="py-2 px-4">{product?.hsncode || "N/A"}</td>
//           <td className="py-2 px-4">{product?.visibilityLevel || "N/A"}</td>
//         </tr>
//       );
//     })}
// </tbody>



//         </table>
//       </div>

//       {/* <div> */}
//       {/* Charges Section
//       <div className="mb-8">
//         <h3 className="text-lg font-semibold text-gray-700 border-b pb-2 mb-2">
//           Charges Breakdown
//         </h3>

//         <div className="space-y-2">
//           {products && products[0]?.visibilityLevel && (
//             <p className="text-gray-600 text-base">
//               Visibility Charges ({products[0].visibilityLevel}): ₹
//               {calculatedVisibilityCharges}
//             </p>
//           )}
//           <pre className="text-sm text-gray-600 whitespace-pre-wrap">
//             {visibiliyCalculationDetails}
//           </pre>
//           <p className="text-gray-600 text-base">Powerpack Charges: ₹{powerPackPrice}</p>
//           {saleMode === "Sale By OGCS" && (
//             <p className="text-gray-600 text-base">Deposit Charges: ₹{depositAmount}</p>
//           )}
//           <p className="text-gray-600 text-base">GST (18%): ₹{gstAmount}</p>
//         </div>

//         <div className="mb-3 border-b pb-3">
//           <h3 className="font-semibold text-gray-700">Final Total Amount</h3>
//           <p className="text-gray-800 font-bold">₹{finalTotalAmount}</p>
//         </div>
//       </div>
//     </div> */}

//       {/* Download Button */}
//       <div className="mt-6 flex justify-end">
//         <button
//           onClick={handleDownloadInvoice}
//           className="flex items-center py-2 px-4 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
//         >
//           <FaDownload className="mr-2" />
//           Download Invoice
//         </button>
//       </div>
//     </div>
//   );
// }

// export default AddProductInvoice;
